class Anchors {
    items: Anchor[] = [];
    public hash: string = '';
    nav = $('nav');

    constructor() {
        this.parse();
        $(window).on('hashchange', this.hashchange.bind(this));
    }

    public parse = () => {
        $('.js-anchor').each((index, item) => {
            const anchorItem = $(item);
            if (!anchorItem.data('anchor')) {
                const anchor = new Anchor(anchorItem);
                anchorItem.data('anchor', anchor);
                this.items.push(anchor);
            }
        });
        this.hashchange(); // No event needed here
    }

    public hashchange = () => {
        const hash = window.location.hash.replace('#', '');
        if (this.hash === hash) return;

        this.hash = hash;

        if (hash) {
            for (let item of this.items) {
                if (item.id === hash) {
                    item.element.addClass('is-active');
                    $('body, html').stop(true).animate({
                        scrollTop: item.target.offset().top - this.nav.outerHeight()!
                    });
                } else {
                    item.element.removeClass('is-active');
                }
            }
        }
    }
}

class Anchor {
    element: JQuery;
    id: string;
    target: JQuery;

    constructor(element: JQuery) {
        this.element = element;
        if (!this.element.length) return;

        this.id = this.element.attr('href')!.split('#').pop()!;
        this.target = $('#' + this.id);

        this.target.attr('id', 'js-' + this.id);
        this.element.on('click', this.click.bind(this));
    }

    public click = (event: JQuery.ClickEvent) => {
    event.preventDefault(); // prevent default anchor jump

    if (this.id === window.location.hash.replace('#', '')) {
        // Scroll manually since hash doesn't change
        $('body, html').stop(true).animate({
            scrollTop: this.target.offset().top - $('nav').outerHeight()!
        });
    } else {
        // Trigger normal hash change by updating the URL
        window.location.hash = this.id;
    }
}

}

// Initialize
let anchors = new Anchors();
